export default "__VITE_ASSET__B5VVlRHC__"